<template>
  <div class="ModalTable">
    <table class="TB_COLLAPSE" width="100%">
      <thead>
        <tr>
          <th v-for="it in columns" :key="it.title">{{ it.title }}</th>
        </tr>
      </thead>
      <tbody>
        <tr :class="{ timerout: trColorStatus }">
          <td width="10%" v-for="(it, index) in columns" :key="it.title" class="pr-2 pl-2">
            <Select
              ref="Select"
              v-model="Select[index]"
              filterable
              @on-query-change="queryChange"
              :not-found-text="notFoundText"
              :disabled="timeLodingStatus === 2"
            >
              <Option value="-">未指定</Option>
              <Option
                v-for="i in NumberSelect(Select[index])"
                :key="it.title + i"
                :value="i"
              >{{ i }}</Option>
            </Select>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

import modalTableGame from '@/mixins/modal-table-game.js'
export default {
  name: 'ModalTableQuick3',
  extends: modalTableGame,
  data () {
    return {
      Select: ['-', '-', '-', '-', '-'],
      NumberLength: 5,
      NumberBallRange: [11, 1],
      columns: [{
        title: '第一球',
        align: 'center',
        width: '80',
        key: 'ball',
      },
      {
        title: '第二球',
        align: 'center',
        width: '80',
        key: 'ball',
      },
      {
        title: '第三球',
        align: 'center',
        width: '80',
        key: 'ball'
      },
      {
        title: '第四球',
        align: 'center',
        width: '80',
        key: 'ball'
      },
      {
        title: '第五球',
        align: 'center',
        width: '80',
        key: 'ball'
      },
      ]
    }
  }
}
</script>